import { useQuery } from 'react-query';

import { fetchVideoList } from '@/api/kiosk';

function useKioskVideoList(kioskId: number | null) {
  return useQuery(['kioskVideoList', kioskId], () => fetchVideoList(kioskId), {
    retry: false,
    enabled: kioskId !== null,
  });
}

export default useKioskVideoList;
